import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberType } from '@app/core/interfaces/c5/phone-number-type';
import { PhoneNumberLike } from '@app/shared/models/phone-number-like';
import { isBlank } from '@app/utils/string';

interface Options {
  format: 'default' | 'compact' | 'clean';
  withoutInternal: boolean;
}

@Pipe({
  name: 'phoneNumber',
  standalone: false,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(
    number: PhoneNumberLike,
    formatOrOptions: 'default' | 'compact' | 'clean' | Partial<Options> = 'default'
  ): any {
    let piped = '';

    let { format, withoutInternal } = this.getOptions(formatOrOptions);

    if (number) {
      if (number.type === PhoneNumberType.INTERNAL) {
        piped = number.internal;
      } else {
        piped = number.sn;

        if (number.internal) {
          if (withoutInternal) {
            piped = piped.replace(new RegExp(number.internal + '$'), '');
          } else {
            piped = piped.replace(new RegExp(number.internal + '$'), '-' + number.internal);
          }
        } else if (number.suffixDigit != null && number.suffixDigit > 0) {
          piped = number.sn.slice(0, number.sn.length - number.suffixDigit);
          piped += `-${number.sn.slice(number.sn.length - number.suffixDigit)}`;
        }

        if (format === 'clean') {
          piped = `+${number.cc}${number.ndc ?? ''}${number.sn}`;
        } else if (format === 'compact') {
          piped = `+${number.cc}${number.ndc ?? ''}${piped}`;
        } else {
          piped = `+${number.cc}/${number.ndc ?? ''}${isBlank(number.ndc) ? '' : '/'}${piped}`;
        }
      }
    }

    return piped;
  }

  private getOptions(formatOrOptions: 'default' | 'compact' | 'clean' | Partial<Options>): Options {
    let format: 'default' | 'compact' | 'clean';
    let withoutInternal: boolean;

    if (typeof formatOrOptions === 'string') {
      format = formatOrOptions;
      withoutInternal = false;
    } else {
      format = formatOrOptions.format ?? 'default';
      withoutInternal = formatOrOptions.withoutInternal ?? false;
    }

    return { format, withoutInternal };
  }
}
